// styling related
import { css } from 'emotion';

export const SMALL_FONT = 'b100';
export const SMALL_FONT_BOLD = 'h100';
export const ERROR_COLOR = css({ color: '#AD0A30' });
export const WARNING_COLOR = css({ color: '#f6d427' });
export const SUCCESS_COLOR = css({ color: '#4ead0a' });
export const BLUE_COLOR = css({ color: '#0b97ce' });

export const IMAGE_STYLE = css({
  height: 26,
  margin: 0,
  width: 26,
});

export const IMAGE_STYLE_LARGE = css({
  height: 100,
  margin: 0,
  width: 100,
});

// Feature related
export const STYLE_STORES = ['US-CA-164', 'US-OH-19'];

// super cat
export const SMALL_COL_MIN_WIDTH = 200;
export const X_LARGE_COL_MIN_WIDTH = 420;

export const IMG_PLACEHOLDER =
  'https://images-na.ssl-images-amazon.com/images/G/02/x-site/icons/no-img-sm._UR320,180_RI_.jpg';

// notication banner
export const DEFAULT_TIME_OUT = 3000;

export enum Newness {
  NET_NEW = 'Net new',
  PREVIOUS_SEASON = 'Previous Season',
}
